import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-formulaire-demat-admin',
  templateUrl: './admin.component.html',
})
export class FormulaireDematAdminComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/pages/cerba/pages/admin/admin.component.ts